import React from 'react';
import { IconButton, makeStyles, Theme, Tooltip } from '@material-ui/core';
import { SaveAlt } from '@material-ui/icons';
import { useTranslation } from '@fluentsms/i18n';
import { useExportDataGridToExcel } from './excelExport/useExportDataGridToExcel';
import { TableInstance } from 'react-table';

const useStyles = makeStyles((theme: Theme) => ({
  headerIcon: {
    '&&': {
      padding: theme.spacing(1.5),
      fontSize: theme.spacing(3),
    },
  },
}));

export interface DataGridExportMenuProps<T extends Record<string, unknown>> {
  table: TableInstance<T>;
  fileName: string;
  sheetName: string;
  onExportClick?: (event: React.MouseEvent) => void;
}

export function DataGridExportMenu<T extends Record<string, unknown>>(props: DataGridExportMenuProps<T>): JSX.Element {
  const { table, fileName, sheetName, onExportClick } = props;

  const classes = useStyles();
  const { t } = useTranslation('common');

  const { exportToExcel } = useExportDataGridToExcel();

  const handleXlsxExportClick = (event: React.MouseEvent) => {
    if (onExportClick) {
      onExportClick(event);
    } else {
      exportToExcel({
        fileName,
        sheetName,
        rows: table.rows,
        visibleColumns: table.visibleColumns,
        prepareRow: table.prepareRow,
        selectedRowIds: table.state.selectedRowIds,
      });
    }
  };

  return (
    <Tooltip title={t('dataGridExportMenu.exportToXlsxTooltip')} arrow placement="top" data-testid="tooltip-export">
      <IconButton className={classes.headerIcon} size="medium" onClick={handleXlsxExportClick}>
        <SaveAlt data-testid="savealt-img" />
      </IconButton>
    </Tooltip>
  );
}

export default DataGridExportMenu;
